import React, { ReactElement } from 'react';
import classNames from 'classnames';
import { useDialogKeyboard, DialogKeyboardConfig } from 'lib/hooks/useDialogKeyboard';
import { closeModal } from '../Modal';
import './index.scss';

interface DialogProps {
  title: string | ReactElement;
  children: ReactElement;
  confirmButtonText?: string | ReactElement;
  closeButtonText?: string;
  customClass?: string;
  showClose?: boolean;
  confirmCallback?: () => void;
  closeCallback?: () => void;
  keyboard?: DialogKeyboardConfig;
}

const Dialog = ({
  title,
  children,
  showClose = true,
  confirmButtonText = '',
  closeButtonText = '',
  customClass = '',
  confirmCallback,
  closeCallback,
  keyboard,
}: DialogProps) => {
  const closeDialog = () => {
    closeModal();
    closeCallback?.();
  };

  const confirm = () => {
    closeModal();
    confirmCallback?.();
  };

  useDialogKeyboard({
    onEnter: keyboard?.onEnter ?? (confirmButtonText ? confirm : false),
    onEscape: keyboard?.onEscape ?? (showClose ? closeDialog : false),
    allowEnterInInput: keyboard?.allowEnterInInput,
  });

  return (
    <div className={classNames('modal-dialog', customClass)}>
      {showClose ? <div className="modal-dialog__close" onClick={closeDialog}></div> : null}
      <div className="modal-dialog__title">{title}</div>
      {children}
      <div className="modal-dialog__footer">
        {closeButtonText ? (
          <div className="modal-dialog__footer--btn close" onClick={closeDialog}>
            {closeButtonText}
          </div>
        ) : null}
        {confirmButtonText ? (
          <div className="modal-dialog__footer--btn confirm" onClick={confirm}>
            {confirmButtonText || '我知道了'}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default Dialog;
